<!-- 站点详情 -->
<template>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>{{data.name}}</span>
      <van-button type="default" round size="small" @click="ifShow = false">返 回</van-button>
    </div>

    <v-touch class="popup_body" @swiperight="ifShow = false">
      <van-image  width="100%" :src="data.msg ? data.msg.image.url : ''"></van-image>

      <!-- 今日油价 -->
      <van-divider  :style="{ color: '#969696', borderColor: '#ccc',fontSize: '16px' }">今日油价</van-divider>
      <van-row gutter="10">
        <van-col span="12" v-for=" (val, key) in data.oil_price" :key="key">
          <van-button class="button" plain size="small" color="#909399">{{val.name + '&nbsp;&nbsp;' + val.price + '元/L'}}</van-button>
        </van-col>
      </van-row>

      <!-- 站点信息 -->
      <van-cell-group v-if="data.score">
        <van-cell title="服务评分:"  icon="star-o" ><van-rate v-model="data.score.score" readonly /></van-cell>
        <van-cell title="联系电话：" icon="phone" :value="data.msg.show_pho"  @click="coll()"></van-cell>
        <van-cell title="站点地址：" icon="location-o" :value="data.msg.add" ></van-cell>
        <van-cell title="公司简介:"  icon="wap-home-o" :value="data.msg.intro" ></van-cell>
      </van-cell-group>

    </v-touch>
  </van-popup>
</template>

<style lang="scss" scoped>
  .van-row {
    padding: 0 15px 15px 15px;
  }

  .today {
    font-size:16px;
    color:#333;
    font-weight:bold;
  }

  .van-divider {
    margin-bottom: 0px;
  }

  .button {
    width: 100%;
    border-radius: 4px;
    margin-top: 10px;
    font-size: 14px;
  }

  .van-cell__title {
    flex: auto;
    width: 25%;
  }

  .van-cell__value {
    flex: auto;
    text-align: left;
    width: 75%;
    color: #000;
  }
</style>
<script>

export default {
  name: 'site_details',
  data () {
    return {
      ifShow: false,
      data: {}
    }
  },

  methods: {
    // 获取站点数据
    show (data) {
      this.data = data
      this.ifShow = true
    },
    // 点击拨号
    coll () {
      window.location.href = 'tel://' + this.data.msg.coll_pho
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/site_details.vue